// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_logoutButton__CMHrh {
  background-color: #18316e;
  cursor: pointer;
  color: #fff;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  gap: 5px;
  font-family: "Inter";
  font-size: 1rem;
  transition: transform 0.3s ease-in-out;
  border-radius: 8px;
  padding: 0.7rem;
  min-width: 8rem;
}

.styles_disabledButton__oN6\\+A {
  background-color: #6b6e76;
  cursor: wait;
  color: #fff;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  gap: 5px;
  font-family: "Inter";
  font-size: 1rem;
  transition: transform 0.3s ease-in-out;
  border-radius: 8px;
  padding: 0.7rem;
  min-width: 8rem;
}

.styles_logoutButton__CMHrh:hover {
  transform: scale(1.1);
}

.styles_logoutButton__CMHrh:active {
  background-color: #1976d2;
}
`, "",{"version":3,"sources":["webpack://./src/components/BlueButton/styles.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,oBAAoB;EACpB,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,oBAAoB;EACpB,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".logoutButton {\n  background-color: #18316e;\n  cursor: pointer;\n  color: #fff;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: none;\n  gap: 5px;\n  font-family: \"Inter\";\n  font-size: 1rem;\n  transition: transform 0.3s ease-in-out;\n  border-radius: 8px;\n  padding: 0.7rem;\n  min-width: 8rem;\n}\n\n.disabledButton {\n  background-color: #6b6e76;\n  cursor: wait;\n  color: #fff;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: none;\n  gap: 5px;\n  font-family: \"Inter\";\n  font-size: 1rem;\n  transition: transform 0.3s ease-in-out;\n  border-radius: 8px;\n  padding: 0.7rem;\n  min-width: 8rem;\n}\n\n.logoutButton:hover {\n  transform: scale(1.1);\n}\n\n.logoutButton:active {\n  background-color: #1976d2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logoutButton": `styles_logoutButton__CMHrh`,
	"disabledButton": `styles_disabledButton__oN6+A`
};
export default ___CSS_LOADER_EXPORT___;
